import { GETTING_NEW_LINK, SET_NEW_LINK_ERRORS, SAVE_NEW_PAYMENT_LINK, RESET_NEW_PAYMENT_LINK } from '../../../../types/conversations/plugins'
import apiConversation from 'api/conversation'

const paymentApi = apiConversation.plugins.payment

const gettingLink = (userId, gettingLink = true) => ({
  userId,
  gettingLink,
  type: GETTING_NEW_LINK,
})

const setNewLinkErrors = (userId, errors = {}) => ({
  userId,
  errors,
  type: SET_NEW_LINK_ERRORS,
})

const updateLink = (userId, link) => (dispatch) => {
  return dispatch({
    userId,
    link,
    type: SAVE_NEW_PAYMENT_LINK,
  })
}

const resetLink = (userId) => (dispatch) => {
  return dispatch({
    userId,
    type: RESET_NEW_PAYMENT_LINK,
  })
}

const createNewLink = (user) => (dispatch) => {
  // dispatch getting link action and resetting errors
  dispatch(gettingLink(user.id))
  dispatch(setNewLinkErrors(user.id))

  return paymentApi
    .createNewLink({ user: user.id, lang: user.locale })
    .then(({ data, status }) => {
      // Important! We're not getting url anymore, update state.
      dispatch(gettingLink(user.id, false))

      if (status !== 200) return dispatch(setNewLinkErrors(user.id, data))
      else return dispatch(updateLink(user.id, data.results))
    })
    .catch((error) => {
      console.error('createNewLink -> error', error) // log real error to the console
      dispatch(gettingLink(user.id, false))
      return dispatch(setNewLinkErrors(user.id, { error: 'server-error' }))
    })
}

export default {
  createNewLink,
  resetLink,
}
